import React from 'react';
import { Tooltip } from '@material-ui/core';
import { Delete } from '@material-ui/icons';

const TrashIcon = ({
	value,
	onClick = () => false,
	tooltip = 'Borrar',
	disabled,
	color = 'light-danger',
	className = '',
}) => {
	return (
		<Tooltip title={tooltip}>
			<span>
				<button
					onClick={onClick}
					disabled={disabled}
					style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
					className={`btn btn-icon btn-sm btn-${
						disabled ? 'light' : color
					} ${className}`}
				>
					<span className={`svg-icon svg-icon-md`}>
						<Delete />
					</span>
				</button>
			</span>
		</Tooltip>
	);
};

export default TrashIcon;
